import { MapContainer, TileLayer, ScaleControl } from "react-leaflet";
import { CARTO_TILE_URL } from "../../lib/geo";
import GeoJsonLayer from "./GeoJsonLayer";

function NorthArrow() {
  return (
    <div
      className="absolute top-3 right-3 z-[500] pointer-events-none flex flex-col items-center"
      aria-label="North arrow"
    >
      <div className="w-9 h-9 rounded-full bg-[#04120c]/80 border border-slate-700 backdrop-blur-md flex items-center justify-center shadow-lg">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 2 L16 13 L12 10.5 L8 13 Z" fill="#22d3ee" stroke="#22d3ee" strokeWidth="0.5" strokeLinejoin="round" />
          <path d="M12 22 L8 11 L12 13.5 L16 11 Z" fill="#334155" stroke="#334155" strokeWidth="0.5" strokeLinejoin="round" />
        </svg>
      </div>
      <span className="mt-0.5 font-mono-data text-[9px] font-bold uppercase tracking-widest text-cyan-400">N</span>
    </div>
  );
}

export default function GeoLayerMap({ layers, layerState, center = [2.74, 101.72], zoom = 11 }) {
  return (
    <div className="relative h-full w-full">
      <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom
        preferCanvas
        attributionControl={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer url={CARTO_TILE_URL} attribution="" crossOrigin="anonymous" />
        {layers
          .filter((l) => layerState[l.id]?.visible)
          .map((l) => (
            <GeoJsonLayer key={l.id} layer={l} opacity={layerState[l.id]?.opacity ?? l.style.opacity ?? 0.6} />
          ))}
        <ScaleControl position="bottomleft" metric imperial={false} />
      </MapContainer>
      <NorthArrow />
    </div>
  );
}
